// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Icon","colBig":"styles_colBig__2hr4m","colSmall":"styles_colSmall__14RTK","shopifyNameWrapper":"styles_shopifyNameWrapper__1g02n"};